/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css, cx } from 'emotion'
import { quint } from '@entrata/portals-common/lib/styled-utils'
import { LIGHT_GRAY } from 'constants/theme'

const StyledDiv = styled('div')`
  width: calc(100% - 32px);
  max-width: 600px;
  background-color: white;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3);
  display: inline-block;
  padding: 24px;
  position: relative;
  text-align: left;
  transition: all ${({ duration }) => duration}ms ${quint.easeInOut};
  max-height: 100%;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${LIGHT_GRAY};
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
`

const transitions = {
  entering: css`
    opacity: 0;
    transform: translateY(50px);
  `,
  entered: css`
    opacity: 1;
    transform: translateY(0);
  `,
  exiting: css`
    opacity: 0;
    transform: translateY(-100%);
  `,
}

const DialogBox = ({ children, className, status, ...props }) => (
  <StyledDiv className={cx(className, transitions[status])} {...props}>
    {children}
  </StyledDiv>
)

DialogBox.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  status: PropTypes.string,
}

export default DialogBox
